import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./CommanButton.css";

const CommanButton = ({
  onClick,
  className,
  margin,
  text,
  border,
  background,
  borderRadius,
  fontSize,
  color,
  fontWeight,
  padding,
}) => {
  const buttonStyle = {
    background,
    borderRadius,
    border,
    fontSize,
    fontWeight,
    color,
    padding,
    margin,
  };

  return (
    <Button
      type="button"
      className={className}
      style={buttonStyle}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default CommanButton;
